import React, { useEffect } from "react";
import Avatar from "@mui/material/Avatar";

import "../../../../assets/css/block-user.css";
import useHttp from "../../../../hooks/useHttp";
import {
  USER_BLOCK_LIST_URL,
  USER_UNBLOCK_URL,
} from "../../../.././utils/api-ends";
import LoaderImg from "../../../../assets/media/loader.gif";

const BlockedList = () => {
  const [blockedUsers, setBlockedUsers] = React.useState([]);
  const { isLoading, sendRequests } = useHttp();
  const { isLoading: unblockLoading, sendRequests: unblockRequests } =
    useHttp();

  useEffect(() => {
    const response = (data) => {
      setBlockedUsers(data.data);
    };

    sendRequests(
      {
        url: USER_BLOCK_LIST_URL,
      },
      response
    );
  }, [sendRequests]);

  const unBlockUser = (userId) => {
    const response = (data) => {
      setBlockedUsers([...blockedUsers.filter((item) => item.id !== userId)]);
    };

    unblockRequests(
      {
        url: USER_UNBLOCK_URL(userId),
        method: "POST",
      },
      response
    );
  };

  return (
    <div className="col-lg-8">
      {isLoading && (
        <div className="d-flex justify-content-center">
          <img style={{ width: "40px" }} src={LoaderImg} alt="" />
        </div>
      )}

      {!isLoading && blockedUsers.length === 0 && <p>Not Found Blocked User</p>}

      {blockedUsers?.map((item) => (
        <div className="user-block-cards" key={item.id}>
          <div className="user-block-name">
            <Avatar
              className="user-block-img"
              alt="Remy Sharp"
              src={item.profile_picture}
            />

            <h1>{item.username}</h1>
          </div>
          <button onClick={() => unBlockUser(item.id)}>
            Unblock
            {unblockLoading && (
              <img
                style={{ width: "25px", marginLeft: "10px" }}
                src={LoaderImg}
                alt=""
              />
            )}
          </button>
        </div>
      ))}
    </div>
  );
};

export default BlockedList;
